function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M38.791 17.125a2.94 2.94 0 0 0 3.938-.188c1.23-1.229 1.146-3.27-.208-4.375-7.48-6.124-17.084-8.395-26.146-6.791l5.396 5.396c6.02-.063 12.083 1.916 17.02 5.958Zm-4.729 3.813a19.34 19.34 0 0 0-5.25-2.709l6.146 6.146c.5-1.208.209-2.646-.896-3.438Zm-8 8.875a8.918 8.918 0 0 0-8.146 0c-1.229.645-1.458 2.333-.479 3.312l3.063 3.063a2.075 2.075 0 0 0 2.937 0l3.063-3.063c1.02-.98.812-2.667-.438-3.313ZM38 33.291 5.583.875a2.075 2.075 0 0 0-2.937 0 2.075 2.075 0 0 0 0 2.938L7.52 8.707C5.417 9.75 3.375 11.021 1.5 12.562c-1.354 1.105-1.438 3.146-.208 4.376 1.062 1.062 2.75 1.166 3.895.208a26.428 26.428 0 0 1 6.771-4.021l4.646 4.646a20.064 20.064 0 0 0-6.646 3.146c-1.437 1.041-1.52 3.145-.27 4.395l.02.021c1.021 1.021 2.625 1.125 3.813.271 2.479-1.75 5.375-2.625 8.27-2.687l13.271 13.27a2.075 2.075 0 0 0 2.938 0c.812-.77.812-2.083 0-2.895Z",
  fill: "url(#a)"
});

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "a",
  x1: -21.163,
  y1: 18.531,
  x2: 14.865,
  y2: 61.109,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#00BAFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#007CFF"
})));

function SvgNoWifi(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 37,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = React.forwardRef(SvgNoWifi);
export default __webpack_public_path__ + "static/media/no-wifi.e14331f0.svg";
export { ForwardRef as ReactComponent };